import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from 'components/typography';
import { TypographyVariants } from 'constants/typography-variants';

import { useDesktopMediaWatcher } from 'hooks/use-desktop-media-watcher.hook';
import { useBackgroundImageService } from 'hooks/use-background-image-service.hook';

import { useStyles } from './styles';

export const AchievementWithAble = () => {
    const { t } = useTranslation();

    const { block } = useStyles();

    const isDesktop = useDesktopMediaWatcher();

    const pageImages = useBackgroundImageService([
        'svg/graphs/achievement-with-able/graph-desktop.svg',
        'svg/graphs/achievement-with-able/graph-mobile.svg',
    ]);

    return (
        <div className={block}>
            <Typography variant={TypographyVariants.h1} typographyNext>
                {t('graphs-title-1')}
            </Typography>

            <Typography variant={TypographyVariants.h2}>
                {t('graphs-description-1')}
            </Typography>

            {isDesktop && <img src={pageImages[0]} alt="Graph" />}
            {!isDesktop && <img src={pageImages[1]} alt="Graph" />}
        </div>
    )
};
